import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';

const StoreCode = ({ labels, errors, touched }) => {
  return (
    <>
      <Label labelName={labels.STORE_CODE} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.storeCode && touched.storeCode ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_STORE_CODE}
          className="select-style"
          name="storeCode"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.storeCode}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

StoreCode.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired
};

export default StoreCode;
